import { createContext } from "react";

// eslint-disable-next-line no-extra-parens
export const Context = createContext<() => Promise<void>>(() =>
  Promise.resolve()
);
